import UpdateUserModule from './UpdateUser.module';

export * from './UpdateUserModuleProps';
export default UpdateUserModule;
